import "./Login.css";
import Logo from "../../assets/images/Logo.png";
// import ImageCarousel from "../../Components/ImageCarousel";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  combineAllRoutes,
  createCookieInHour,
  emailValidation,
  filterRouteData,
  findSelectedObjectElementIsEmpty,
  setLocalStorage,
} from "../../Functions/Utils";
import { ManageApis } from "../../AppServices/ManageApi";
import AlertBox from "../../Components/AlertBox/AlertBox";
import Loader from "../../Components/LoaderComponent/Loader";
import { routeList } from "../../globalData/constant";
import { useStoreValues } from "../../Context/storeProvider";

function Login() {
  const { user_Roll, setUser_Roll, menuList, setMenuList, setUser } = useStoreValues();
  const [login, setLogin] = useState({
    email: "",
    password: "",
    rememberMe: true,
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isPassword, setIsPassword] = useState(true);
  const [visible, setvisible] = useState({ show: false, message: "" });
  const Navigate = useNavigate();

  useEffect(() => {
    // localStorage.clear();
    // //console.log(menuList)
  }, [menuList]);




  const handlesubmit = async () => {
    ""
    try {
      if (Object.keys(login).some((itm) => login[itm] === "")) {
        Object.keys(login).forEach((itm) => {
          if (login[itm] === "") {
            handleError(`Please fill the field`, itm);
          } else {
            handleError(``, itm);
          }
        });
        return;
      }
        
    
      
      setIsLoading(true);

      let result = await ManageApis("post", global.Login, login);
      //console.log(result.response_data);
      if (result?.message === "Success") {
        //console.log(result?.response_data);
        // Navigate("/aadhar_Masking")
        // //console.log(combineAllRoutes(filterRouteData(routeList, result?.response_data?.menuList[0])))
        // ""
        // let formatingMenuList = [{ menuName: "landing" }, { menuName: "DashBoard" }]
        let formatingMenuList = result?.response_data?.menuList
        // //console.log(formatingMenuList);
        // console.log([...formatingMenuList, { menuName: "api-logs" }, 
        // { menuName: "hitdashboard" }, 
        // { menuName: "hitoverview" }])
        setLocalStorage({
          menuList: JSON.stringify(
            formatingMenuList.length > 0 ? [...formatingMenuList, { menuName: "api-logs" },{ menuName: "service-logs" },
            // { menuName: "hitdashboard" },
            { menuName: "hitoverview" }] : [{ menuName: "landing" }, { menuName: "api-logs" }, { menuName: "service-logs" },{ menuName: "hitdashboard" }, { menuName: "hitoverview" }]
          ),
          clientId: result?.response_data?.id,
          email: result.response_data.emailId,
          user_roll: result?.response_data?.role,
          user: result?.response_data?.userName,
          accountsList: JSON.stringify(result?.response_data?.accountsList),
          access_token: result?.response_data?.token,
          userId:result?.response_data?.userId,
          accountsId: result?.response_data?.accountsId,
          oldAccountId:result?.response_data?.oldAccountId
        });

        setUser_Roll(result?.response_data?.role);
        setUser(result?.response_data?.userName)
        setTimeout(() => { }, 1000);


        createCookieInHour("ueserRoll", "Client", 4)
        // ""
        if (["Admin","AdminClient"].includes(result.response_data.role)) {
          Navigate("/admin/user_list");
        } else {
          setMenuList(
            formatingMenuList.length > 0 ? [...formatingMenuList, { menuName: "landing" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }] : [{ menuName: "landing" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }]
          );
          // console.log('length of list --->', formatingMenuList.length, filterRouteData(routeList, formatingMenuList.map((itm) => itm.menuName)), combineAllRoutes(
          // filterRouteData(routeList, formatingMenuList.map((itm) => itm.menuName))
          // )[0]?.path)
          
          formatingMenuList =  [...formatingMenuList, { menuName: "chatbot" }] // chatbot menu added
  Navigate(
    // formatingMenuList.length > 0
    //   ? combineAllRoutes(
    //     filterRouteData(routeList, formatingMenuList.map((itm) => itm.menuName))
    //   )[0]?.path
    //   :
    "/landing", { state: { formatingMenuList } }
  );
  
}

setIsLoading(false);
      } else {
  if (result?.status_code === 401) {
    setvisible((pre) => ({
      show: true,
      message: "Please check the Username or Password",
    }));

  } else if (result?.status_code === 400) {
    setvisible((pre) => ({ show: true, message: result.response_data }));

  }
  else {
    setvisible((pre) => ({ show: true, message: result?.message }));
  }
  setIsLoading(false);
}
    } catch (err) {
  setIsLoading(false);
  // //console.log(err);
}
  };
useEffect(() => {
  // //console.log(login);
}, [login]);

const handleChange = (e) => {
  const { name, value } = e.target;
  Validate(name, value);
  setLogin((pre) => ({ ...pre, [name]: value }));
};

const Validate = (name, value) => {
  let isValid = true;
  switch (name) {
    case "email":
      if (value) {
        handleError("", "email");
      }
      // if (!emailValidation(value)) {
      //   handleError("Please enter a valid Email", "email");
      //   isValid = false;
      // } else {
      //   handleError("", "email");
      // }
      break;

    case "password":
      if (value.length < 4) {
        handleError("Please enter a valid Password", "password");
        isValid = false;
      }else {
        handleError("", "password");
      }

      break;
    default:
      break;
  }

  return isValid;
};
const handleError = (error, input) => {
  setErrors((prevState) => ({ ...prevState, [input]: error }));
};

useEffect(() => {
  // //console.log(Object.keys(errors).length > 0, errors);
}, [errors]);

const handlecancel = () => {
  setvisible((pre) => ({ show: false, message: "" }));
};

const handleKeyDown = (event, currentIndex) => {
  const { key } = event;

  if (key == "Enter") {
    if (findSelectedObjectElementIsEmpty(login, ["email", "password"])) {
      // //console.log(event);

      const inputFields = document.querySelectorAll(".form-control");
      const nextIndex = (currentIndex + 1) % inputFields.length;
      const nextInput = inputFields[nextIndex];
      if (nextInput) {
        nextInput.focus();
      }
    } else {
      handlesubmit();
    }
  }
};

const HandleRegister = () =>{
  Navigate('/Register')
}

return (
  <div className="bg_masterdark h_100vh">
    {
      <AlertBox
        show={visible?.show}
        handlecancel={handlecancel}
        message={visible?.message}
      />
    }
    {isLoading && <Loader />}
    <div className="d-flex h-100 p-4">
      <div className="br_25 m-auto overflow-hidden w-100 flex-column flex-sm-row d-flex loginbx">
        <div className="login_left">
          <div className="p-4 text-white position-relative zi_1">
            <div className="p-0 p-sm-1">
              <img src={Logo} className="mb-4 logo_prop" />
              <h2 className="h4 fw_600 font_21 mb-0 mb-sm-3 pb-0 pb-sm-2">
                Experience the Benefits of Powerful AI with Highest Accuracy.
              </h2>
              <div className="d-none d-sm-block">
                <p className="font_12 fw_200 lh-base">
                  We listen and adapt our ways according to your project
                  needs. You get all the benefits of working with a truly
                  flexible and technology expertise team while avoiding all
                  the mess of having to build and maintain one.
                </p>
                {/* <div className="d-flex gap-3 pt-3">
                  <div>
                    <img src={Product1} className="w-100 rounded-3"/>
                    <h5>Aadhaar Masking</h5>
                  </div>
                  <div>
                    
                  <img src={Product2} className="w-100 rounded-3"/>
                  </div>
                </div> */}
                {/* <div>
                  <ImageCarousel />
                </div> */}
              </div>
            </div>
          </div>
        </div>
        <div className="login_right bg-white h-100">
          <div className="d-flex h-100 p-4">
            <div className="m-auto max_w_350x py-3 w-100">
              <div>
                <h1 className="h3 text-center text_gray1 fw_600">Login</h1>
                <p className="text-center text_gray1 fw_500 pb-3 d-none d-sm-block">
                  Login to experience the benefits of <br />
                  powerful AI
                </p>
                <div className="mb-3">
                  <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                    Email or Username<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control rounded-pill font_12"
                    placeholder="Enter your email"
                    name="email"
                    id="email"
                    autoComplete="off"
                    maxLength={50}
                    onChange={handleChange}
                    value={login?.email}
                    onKeyDown={(e) => handleKeyDown(e, 0)}
                  />
                  {errors&&<span className="text-danger font_11">{errors?.email}</span>}
                </div>
                <div className="mb-3 pb-1">
                  <label className="mb-0 pb_2x text_gray1 fw_500 font_14">
                    Password<span className="text-danger">*</span>
                  </label>

                  <div className="input_withicon end">
                    <input
                      type={isPassword ? "password" : "text"}
                      className="form-control rounded-pill font_12 with_icon"
                      placeholder="Enter your password"
                      name="password"
                      id="password"
                      autoComplete="off"
                      onChange={handleChange}
                      value={login?.password}
                      maxLength={50}
                      onKeyDown={(e) => handleKeyDown(e, 1)}
                    />
                    <i
                      className="far fa-eye  icn p-2 text_gray"
                      onClick={() => setIsPassword(!isPassword)}
                    ></i>
                  </div>
                  {errors&&<span className="text-danger font_11">{errors?.password}</span>}
                </div>

                <div>
                  <button
                    type="submit"
                    className="btn px_btn btn-master px-4 rounded-pill w-100 fw_500"
                    onClick={handlesubmit}

                  // disabled={Object.values(login).length < 0 }
                  >
                    Login
                  </button>
                </div>
                <div className="text-center mt-5 font_14">
                  Don't have an account ? <span onClick={HandleRegister} className="font_500 cursor-pointer text_master">Register</span> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  // {/* <div  className="bg_masterdark h_100vh">
  // <div className="d-flex justify-content-center px-4">
  //   <div className="bg-white loginBox shadow_sm2">
  //     <div className="row py-3">
  //       <div className="d-flex login_right_sec px-3">
  //         <div className="px-3 px-md-5 py-2 py-md-5">
  //           <h1 className="font_22 text_master fw_bold mb-2">Sign In</h1>
  //           <p className="text_gray2">
  //             Sign in you have an account in here{" "}
  //           </p>
  //           <div className="row">
  //             <div className="col-12 mt-2">
  //               <div className="d-grid mt-3">
  //                 <label className="mb-0 px-1 text_gray2">
  //                   UserName<span className="text-danger">*</span>
  //                 </label>
  //                 <input
  //                   type="text"
  //                   className="form-control bg_light br_10"
  //                   placeholder="Enter your username "
  //                   //onChange={}
  //                 />
  //               </div>
  //             </div>
  //             <div className="col-12">
  //               <div className="d-grid mt-3">
  //                 <label className="mb-0 px-1 text_gray2">
  //                   Password<span className="text-danger">*</span>
  //                 </label>
  //                 <input
  //                   type="password"
  //                   className="form-control bg_light br_10"
  //                   placeholder="Enter your password"
  //                   //onChange={}
  //                 />
  //               </div>
  //             </div>
  //           </div>
  //           <div className="d-flex justify-content-end mt-3">
  //             <button
  //               type="submit"
  //               className="btn px_btn btn-master px-4 br_10 "
  //               //onClick={handlesubmit}
  //             >
  //               SIGN IN
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // </div>
  // </div> */}
);
}

export default Login;
